import { apiFetch } from '@ami/react/core';
import { MachineFilter } from './machineFilter';
import { MachineOutput as MachineOuput } from './machineOutput';
import { machineStatus } from './machineStatusType';

const _baseEndPoint = 'machines';

export const PartNumberCategory = Object.freeze({
  Standard: 'Standard',
  RecessedBucket: 'Recessed Bucket',
  WBMWedgeCoupler: 'WBM Wedge Coupler',
});

export class Machine {
  constructor(item) {
    if (item) {
      this.id = item.id;
      this.carrierId = item.carrierId;
      this.type = item.type;
      this.manufacturer = item.manufacturer;
      this.weightCategoryId = item.weightCategoryId;
      this.weightCategory = item.weightCategoryDescription;
      this.weightCategoryDescription = item.weightCategoryDescription;
      this.weightCategoryName = item.weightCategoryName;
      this.model = item.model;
      this.activities = item.activities;
      this.attachmentPointConfigurations = item.attachmentPointConfigurations
        ? item.attachmentPointConfigurations.map(
            (x) => new AttachmentPointConfiguration(x)
          )
        : [];
      this.status = item.status;
      this.statusName = item.statusName;
      return;
    }
    this.id = null;
    this.carrierId = null;
    this.type = null;
    this.manufacturer = null;
    this.weightCategoryId = null;
    this.weightCategory = null;
    this.weightCategoryName = null;
    this.weightCategoryDescription = null;
    this.model = '';
    this.activities = [];
    this.attachmentPointConfigurations = [];
    this.status = machineStatus.PendingApproval;
    this.statusName = '';
  }

  static async search(filter = new MachineFilter(), page) {
    filter.setPaginationParameters(page);
    const entities = await apiFetch(
      `${_baseEndPoint}?${filter.toQueryString()}`
    );
    return entities.map((x) => new Machine(x));
  }

  static async searchList(filter = new MachineFilter(), page) {
    filter.setPaginationParameters(page);
    const entities = await apiFetch(
      `${_baseEndPoint}/list?${filter.toQueryString()}`
    );
    return entities.map((x) => new MachineOuput(x));
  }

  static async getById(id) {
    const entity = await apiFetch(`${_baseEndPoint}/${id}`);
    return new Machine(entity);
  }

  static async copyFrom(id) {
    const json = await apiFetch(`${_baseEndPoint}/copy-from/${id}`);
    return new Machine(json);
  }

  static create(item) {
    return apiFetch(_baseEndPoint, 'POST', item);
  }

  static async getForExport(filter = new MachineFilter()) {
    return await apiFetch(
      `${_baseEndPoint}/export/csv?${filter.toQueryString()}`
    );
  }
}

export class AttachmentPointConfiguration {
  constructor(item) {
    if (item) {
      this.attachmentPointId = item.attachmentPointId;
      this.couplerControlKit = item.couplerControlKit || '';
      this.thumbConfiguration = item.thumbConfiguration
        ? new ThumbConfiguration(item.thumbConfiguration)
        : new ThumbConfiguration();
      this.oemPinUpId = item.oemPinUpId;
      this.oemPinUpName = item.oemPinUpName || '';
      // these props are only used for the view
      this.amiClassPinUpId = item.amiClassPinUpId;
      this.amiClassPinUpName = item.amiClassPinUpName;
      this.amiClassShimKitId = item.amiClassShimKitId;
      this.amiClassShimKitName = item.amiClassShimKitName;
      this.forceUseAmiClassPinUpAndShimKit =
        item.forceUseAmiClassPinUpAndShimKit;
      return;
    }
  }
}

export class ThumbConfiguration {
  constructor(item) {
    if (item) {
      this.alwaysIncludeOverridePartNumber =
        item.alwaysIncludeOverridePartNumber;
      this.overridePartNumber = item.overridePartNumber || '';
      this.oemThumbMount = item.oemThumbMount;
      this.boltOnMountPartNumber = item.boltOnMountPartNumber || '';
      return;
    }
    this.overridePartNumber = '';
    this.boltOnMountPartNumber = '';
  }
}
